import { getQueryVariable } from "../intl";
import { useAppContext } from "../useAppContext";
import { useDeviceUA } from "@dbn/omnichannel-design-system-g4p";

function compareVersions(v1: string, v2: string) {
  const a = v1.split(".").map(Number);
  const b = v2.split(".").map(Number);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const diff = (a[i] || 0) - (b[i] || 0);
    if (diff !== 0) return diff > 0 ? 1 : -1;
  }
  return 0; // equal
}

export function useCompareAppVersions() {
  const { isIOS, isAndroid } = useDeviceUA();

  const {
    config: {
      firstIOSMobileAppVersionDownloadWithPost,
      firstAndroidMobileAppVersionDownloadWithPost,
    },
  } = useAppContext();

  const appVersion = getQueryVariable("appVersion");

  const firstPostCompatibleVersion = isIOS
    ? firstIOSMobileAppVersionDownloadWithPost
    : isAndroid
    ? firstAndroidMobileAppVersionDownloadWithPost
    : "";

  const isPostDownloadCompatible = () => {
    if (appVersion === "" || firstPostCompatibleVersion === "") {
      return false;
    }
    const compareResult = compareVersions(
      appVersion,
      firstPostCompatibleVersion
    );
    return compareResult !== -1;
  };

  return {
    isPostDownloadCompatible: isPostDownloadCompatible(),
  };
}
